<template>
  <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0" id="setting-crypto-page">

    <vx-card title="แก้ไข Rate ราคา">
      <!-- toolbar + สรุป -->
      <div class="flex flex-wrap items-center mb-4">
        <div class="flex flex-wrap items-center">
          <vs-chip color="primary" class="mr-2">ทั้งหมด {{ infoRank.length }} รายการ</vs-chip>
          <vs-chip color="success" class="mr-2">เปิด {{ countActive }}</vs-chip>
          <vs-chip color="danger">ปิด {{ countInactive }}</vs-chip>
        </div>

        <div class="ml-auto mt-3 md:mt-0">
          <vs-button color="primary" type="border" size="small" icon-pack="feather" icon="icon-rotate-cw"
            @click="callinfo()">
            Refresh
          </vs-button>
        </div>
      </div>

      <vs-table stripe :data="infoRank">
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>เหรียญ</vs-th>
          <vs-th>Network</vs-th>
          <vs-th>เรท (THB)</vs-th>
          <vs-th>สถานะ</vs-th>
          <vs-th>จัดการ</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="tr.id || indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.id">
              <span class="font-semibold">#{{ tr.id }}</span>
            </vs-td>

            <vs-td :data="tr.coin">
              <div class="flex items-center">
                <div class="coin-logo mr-3">
                  <img v-if="tr.image" :src="tr.image" :alt="tr.coin" @error="onImageError">
                  <span v-else class="coin-logo__fallback">{{ (tr.coin || '?').charAt(0) }}</span>
                </div>
                <div>
                  <div class="font-semibold">{{ tr.coin || '-' }}</div>
                  <div class="text-sm text-grey">{{ tr.text || '-' }}</div>
                </div>
              </div>
            </vs-td>

            <vs-td :data="tr.network">
              <vs-chip color="primary">{{ (tr.network || '-') | uppercase }}</vs-chip>
            </vs-td>

            <vs-td :data="tr.thb_rate">
              <div class="font-semibold">{{ currency(tr.thb_rate) }} ฿</div>
              <div class="text-sm text-grey">1 {{ tr.coin || 'coin' }} = {{ currency(tr.thb_rate) }} บาท</div>
            </vs-td>

            <vs-td :data="tr.status">
              <vs-chip :color="tr.status ? 'success' : 'danger'">
                {{ tr.status ? 'เปิด' : 'ปิด' }}
              </vs-chip>
            </vs-td>

            <vs-td :data="tr.id">
              <vs-button :disabled="!canAction" type="border" size="small" icon-pack="feather" icon="icon-edit"
                class="mr-2" @click="edit(indextr)">แก้ไข</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div v-if="!loading && infoRank.length === 0" class="text-center py-6 text-grey">
        ไม่พบข้อมูลเหรียญ
      </div>
    </vx-card>

    <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showpopup">
      <div class="crypto-edit">
        <!-- ข้อมูลเหรียญ (ดูได้ ไม่ให้แก้) -->
        <div class="crypto-edit__head flex items-center">
          <div class="coin-logo coin-logo--lg mr-3">
            <img v-if="infopopup.image" :src="infopopup.image" :alt="infopopup.coin" @error="onImageError">
            <span v-else class="coin-logo__fallback">{{ (infopopup.coin || '?').charAt(0) }}</span>
          </div>
          <div class="flex-grow">
            <div class="font-semibold">{{ infopopup.text || infopopup.coin }}</div>
            <div class="text-sm text-grey mt-1">
              เหรียญ {{ infopopup.coin || '-' }} &nbsp;·&nbsp; ID {{ infopopup.id || '-' }}
            </div>
          </div>
          <vs-chip color="primary">{{ (infopopup.network || '-') | uppercase }}</vs-chip>
        </div>

        <!-- เรท -->
        <div class="crypto-edit__field">
          <label class="crypto-edit__label">เรทราคา (บาท)</label>
          <vs-input class="w-full" v-model="infopopup.rate" type="number" min="0" step="0.01"
            icon-pack="feather" icon="icon-dollar-sign" icon-no-border placeholder="0.00" name="rate" />
          <div class="text-sm text-grey mt-2">
            1 {{ infopopup.coin || 'coin' }} = <span class="font-semibold">{{ currency(infopopup.rate) }} ฿</span>
            <span v-if="rateChanged" class="text-warning ml-1">(เดิม {{ currency(originalRate) }} ฿)</span>
          </div>
        </div>

        <!-- สถานะ -->
        <div class="crypto-edit__field">
          <label class="crypto-edit__label">สถานะการใช้งาน</label>
          <div class="flex items-center">
            <vs-switch :disabled="!canAction" v-model="infopopup.status" class="mr-3">
              <span slot="on">เปิด</span>
              <span slot="off">ปิด</span>
            </vs-switch>
            <span :class="infopopup.status ? 'text-success' : 'text-danger'" class="text-sm font-semibold">
              {{ infopopup.status ? 'เปิดให้ใช้งาน' : 'ปิดไม่ให้ใช้งาน' }}
            </span>
          </div>
        </div>

        <!-- OTP -->
        <div class="crypto-edit__field">
          <label class="crypto-edit__label">OTP</label>
          <vs-input class="w-full" v-model="infopopup.otp" icon-pack="feather" icon="icon-lock" icon-no-border
            placeholder="กรอกรหัส OTP" name="otp" />
          <small class="text-danger">กรุณากรอก OTP ทุกครั้งเพื่อยืนยันการแก้ไข</small>
        </div>

        <div class="crypto-edit__footer flex flex-wrap items-center justify-end">
          <vs-button type="border" color="dark" size="small" class="mr-2" @click="showpopup = false">ยกเลิก</vs-button>
          <vs-button :disabled="!canAction || saving || !infopopup.otp" color="success" size="small" icon-pack="feather"
            icon="icon-save" @click="confirm_edit()">
            {{ saving ? 'กำลังบันทึก...' : 'ยืนยัน' }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axios from '../../axios'

export default {
  filters: {
    uppercase (value) {
      return String(value || '').toUpperCase()
    }
  },
  data () {
    return {
      loading: false,
      saving: false,
      infoRank: [],
      showpopup: false,
      originalRate: '',
      infopopup: {
        id: '',
        coin: '',
        text: '',
        image: '',
        network: '',
        rate: '',
        status: '',
        otp: ''
      },
      error: ''
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    canAction () {
      const appUser = this.$store && this.$store.state && this.$store.state.AppActiveUser
      const permissions = appUser && appUser.permissions
      if (!permissions || !permissions.setting) return false
      return !!permissions.setting.action
    },
    countActive () {
      return this.infoRank.filter(item => item.status === true).length
    },
    countInactive () {
      return this.infoRank.filter(item => item.status !== true).length
    },
    rateChanged () {
      return Number(this.infopopup.rate) !== Number(this.originalRate)
    },
    popupTitle () {
      if (!this.infopopup.coin) return 'แก้ไข Rate'
      const network = this.infopopup.network ? ` (${String(this.infopopup.network).toUpperCase()})` : ''
      return `แก้ไข Rate - ${this.infopopup.coin}${network}`
    }
  },
  mounted () {
    this.callinfo()
  },
  methods: {
    async callinfo () {
      this.loading = true
      try {
        const response = await axios.get('/crypto/info')
        this.infoRank = Array.isArray(response.data) ? response.data : []
      } finally {
        this.loading = false
      }
    },
    onImageError (event) {
      event.target.style.display = 'none'
    },
    currency (amount) {
      const number = Number(amount)
      if (amount === null || amount === '' || typeof amount === 'undefined' || isNaN(number)) return '-'
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    edit (index) {
      const item = this.infoRank[index]
      this.infopopup.id = item.id
      this.infopopup.coin = item.coin
      this.infopopup.text = item.text
      this.infopopup.image = item.image
      this.infopopup.network = item.network
      this.infopopup.rate = item.thb_rate
      this.infopopup.status = item.status
      this.infopopup.otp = ''
      this.originalRate = item.thb_rate
      this.showpopup = true
    },
    async confirm_edit () {
      if (this.saving) return
      this.saving = true
      try {
        await axios.post('/crypto/editinfo', {
          id: this.infopopup.id, // ระบุแถวให้ตรงตัว กัน backend update ทับทุก network ที่ coin เดียวกัน
          coin: this.infopopup.coin,
          rate: this.infopopup.rate,
          statusCoin: this.infopopup.status,
          token : this.infopopup.otp
        })
          .then(response => (this.error = response.data))
        if (this.error.status === true) {

          this.$vs.notify({
            time: 10000,
            color: 'success',
            position: 'top-right',
            icon: 'error',
            text: this.error.info,
            title: 'ทำรายการสำเร็จ'
          })
          this.callinfo()
          this.showpopup = false
          this.infopopup.otp = ''
        } else {
          this.callinfo()
          this.showpopup = false
          this.infopopup.otp = ''
          this.$vs.notify({
            time: 10000,
            color: 'danger',
            position: 'top-right',
            icon: 'error',
            text: this.error.info,
            title: 'ทำรายการผิดพลาด'
          })

        }
      } finally {
        this.saving = false
      }
    }
  }
}

</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

/* ใช้ทั้งในตารางและใน popup (vs-popup อาจถูกย้ายไปแขวนที่ body) */
.coin-logo {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &--lg {
    width: 48px;
    height: 48px;
  }

  &__fallback {
    font-weight: 600;
    color: #626262;
  }
}

.crypto-edit {
  padding: 4px 2px;

  &__head {
    padding: 12px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.03);
    margin-bottom: 22px;
  }

  &__field {
    margin-bottom: 22px;
  }

  &__label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #626262;
    margin-bottom: 6px;
  }

  &__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    padding-top: 16px;
    margin-bottom: 0;
  }
}
</style>
